/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-07-01 15:52:43
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\store\fddsign.ts
 */
import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import { ResponseData } from '@/utils/request';
import {ShipmentOrderType} from '@/services/data.d'
import {fddAuthentication, fddContract} from '@/services/fddsign'


export interface StateType {
    errorMsg?: string;
    signUrl: string;
}

export interface ModuleType extends StoreModuleType<StateType> {
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        geturl: Mutation<StateType>;
    };
    actions: {
        fddAuthenticationFn: Action<StateType,StateType>;
        fddContractFn: Action<StateType,StateType>;
    };
}

const initState: StateType = {
    errorMsg: undefined,
    signUrl: ''
};

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'fddsign',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        geturl(state, payload) {
            state.signUrl = payload;
        },
    },
    actions: {
        //法大大认证
        async fddAuthenticationFn({ commit },params:ShipmentOrderType){
            let msg: string | undefined = undefined
            try{
                const req:ResponseData = await fddAuthentication(params)
                const {body:{attestationUrlLink}} = req
                commit('geturl', attestationUrlLink)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //法大大合同签署
        async fddContractFn({ commit },params:ShipmentOrderType){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await fddContract(params)
                const {body:{signUrlLink}} = req
                commit('geturl', signUrlLink)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
    }
}

export default StoreModel
